import {Splide} from "@splidejs/splide";

document.addEventListener('DOMContentLoaded', function (dom) {
    const jsPartnersSlider = dom.target.querySelector('.js-partners-slider')

    if (jsPartnersSlider) {
        const splideInstanceReviews = new Splide(jsPartnersSlider, {
            perPage: 1,
            arrows: false,
            pagination: false,
            destroy: true,
            gap: '30px',
            breakpoints: {
                991: {
                    perPage: 2,
                    destroy: false,
                },
            },
        })
        splideInstanceReviews.mount()
    }
});
